<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Items") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'item.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <advanced-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1 mt-4"
        :filterCols="filterCols"
        :filters="filters"
        v-on:filter="
          filters = $event;
          getData();
        "
        :footer-props="{
          'items-per-page-options': [10, 15, 50, -1]
        }"
      >
        <template v-slot:item.image="{ item }">
          <v-avatar v-if="hasIcon(item)" class="mr-2" size="33">
            <img :src="hasIcon(item).thumb | addToken" />
          </v-avatar>
        </template>
        <template v-slot:item.type="{ item }">
          {{ itemTypeLabel(item.type) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="duplicateItem(item)">
            mdi-content-duplicate
          </v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></advanced-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import {
  fetchItems,
  deleteItem,
  duplicateItem,
  fetchCategories
} from "../shared/services";
import { persistentTableOptions } from "../../../plugins/mixins";

import axios from "axios";
var cancel;
var CancelToken = axios.CancelToken;

export default {
  name: "app-item-list",
  mixins: [persistentTableOptions],
  data() {
    return {
      headers: [
        {
          text: "Vorschau",
          value: "image",
          sortable: false
        },
        {
          text: "Code",
          align: "left",
          value: "code"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: this.$t("type"),
          align: "left",
          value: "type"
        },
        {
          text: "Category",
          align: "left",
          value: "category.name"
        },
        { text: "", value: "action", sortable: false }
      ],
      loading: true,
      options: {
        itemsPerPage: 50
      },
      total: 0,
      search: "",
      items: [],
      categoryFilterItems: [],
      filters: []
    };
  },

  computed: {
    itemTypeFilterItems() {
      return [
        { id: "general", name: this.$t("item_type_general") },
        { id: "glass", name: this.$t("item_type_glass") },
        { id: "filling", name: this.$t("item_type_filling") },
        { id: "fitting", name: this.$t("item_type_fitting") },
        { id: "wood", name: this.$t("item_type_wood") },
        { id: "threshold", name: this.$t("item_type_threshold") }
      ];
    },
    filterCols() {
      return [
        {
          title: this.$t("code"),
          name: "code",
          type: "text"
        },
        {
          title: this.$t("name"),
          name: "name",
          type: "text"
        },
        {
          title: this.$t("type"),
          name: "type",
          type: "select",
          props: {
            itemText: "name",
            itemValue: "id"
          },
          items: this.itemTypeFilterItems
        },
        {
          title: this.$t("category"),
          name: "category_id",
          type: "select",
          props: {
            itemText: "name",
            itemValue: "id"
          },
          items: this.categoryFilterItems
        }
      ];
    }
  },

  mounted() {
    this.getData();
    fetchCategories().then(res => {
      this.categoryFilterItems = res.data;
    });
  },

  methods: {
    async getData() {
      //Workaround: Get data only when search term or options are set - problem init
      if (this.options.itemsPerPage || this.search) {
        this.loading = true;
        if (cancel != undefined) {
          cancel();
        }
        let response = await fetchItems(
          {
            ...this.options,
            search: this.search,
            filters: this.filters
          },
          new CancelToken(function executor(c) {
            cancel = c;
          })
        );
        this.items = response.data;
        this.total = response.meta.total;
        this.loading = false;
      }
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Item?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "item.edit", params: { id: url } });
    },
    async duplicateItem(item) {
      let url = item.id;
      let resp = await duplicateItem(item.id);
      if (resp.success) {
        this.$notification(resp.message, { type: "success" });
      } else {
        this.$notification(resp.message, { type: "error" });
      }
      this.getData();
    },
    hasIcon(item) {
      return item.documents.find(doc => {
        return doc.mime_type.startsWith("image/");
      });
    },
    itemTypeLabel(type) {
      const row = this.itemTypeFilterItems.find(t => t.id == type);
      return row ? row.name : type;
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
